import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * ççº§è¡æ¿åº
 */
@JsonObject
export class Province {
  /**
   * ççº§è¡æ¿åºId
   */
  @JsonProperty('id', Number)
  id: number = undefined;

  /**
   * ççº§è¡æ¿åºåç§°
   */
  @JsonProperty('name', String)
  name: string = undefined;
}
